import { makeStyles } from '@material-ui/core'
import shadows from '@material-ui/core/styles/shadows'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  },
  roleSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  searchInput: {
    marginBottom: 12
  },
  clearIconButton: {
    position: 'absolute',
    top: '5%',
    right: 32,
    cursor: 'pointer'
  },
  clearIcon: {
    fontSize: 16
  },
  entitySelectorContainer: {
    width: '46%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  resourceTypeSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  selector: {
    width: '100%',
    position: 'relative'
  },
  selectorContainer: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '1fr',
    gridGap: 12,
    marginTop: 15,
    position: 'relative'
  },
  selectorContainerFullWidth: {
    gridTemplateColumns: '1fr'
  },
  switch: {
    position: 'absolute',
    right: 0,
    top: -12,
    zIndex: 100
  },
  listItem: {
    marginTop: 5,
    padding: 5,
    marginLeft: 5
  },
  listItemHeader: {
    marginTop: 5,
    padding: 1,
    marginLeft: 1
  },
  OptionsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    height: 300,
    width: 300
  },
  datePickerContainer: {
    position: 'absolute',
    left: 0,
    top: 24,
    zIndex: 10,
    '&>div': {
      boxShadow: shadows[3]
    }
  },
  calendars: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 20,
    paddingBottom: 12
  },
  inputContainer: {
    position: 'relative',
    cursor: 'pointer'
  }
}))

export default useStyles
